// extracted by mini-css-extract-plugin
module.exports = {"label":"_38b61f0","container":"_abe4ed5"};